import React, { useContext, useState } from 'react';
import { Modal } from 'flowbite-react';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import MyNewsContext from '../context/NewsContext';

import Loading from './Loading';
import ErrorWrapper from './ErrorWrapper';

export const cutSpaces = (text) => {
    return text.replace(/\n{3,}/, '\n\n').replace(/ +/g, ' ');
}

const style = {
    formInput: "block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-teal-500 peer",
    formLabel: "peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-2 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-teal-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
}

const ModalNewsAdd = ({ isModalNewsAddOpen, setIsModalNewsAddOpen, setSuccessAlert }) => {
    const { addNew, loading, error, setError } = useContext(MyNewsContext)

    const schema = yup.object().shape({
        newTitle: yup.string().required("El titulo es requerido").max(120, "El titulo no puede tener más de 120 caracteres").min(5, "El titulo no puede tener menos de 5 caracteres").trim().transform((currentValue) => cutSpaces(currentValue)),
        newDescription: yup.string().required("La descripción es requerida").max(2120, "La descripcion no puede tener mas de 2120 caracteres").min(5, "La descripción no puede tener menos de 5 caracteres").trim().transform((currentValue) => cutSpaces(currentValue)),
        newFile: yup.mixed()/* .transform((currentValue) => {compressImage(currentValue[0])}) */
            .test({
                message: "La imagen es requerida y debe ser formato png, jpg o jpeg menor de 10 Mb",
                test: (file) => {
                    if (file.length === 0) return false
                    const isValid = ["png", "jpeg", "jpg"].includes(file[0].type.split("/")[1])
                    if (!isValid) return false
                    return file[0].size <= 10000000
                }
            }),
        newDocument: yup.mixed()
            .test({
                message: "El archivo debe ser un pdf menor de 10 Mb",
                test: (file) => {
                    if (file.length > 0) {
                        const isValid = ["pdf"].includes(file[0].type.split("/")[1])
                        if (!isValid) return false
                        return file[0].size <= 10000000
                    }
                    return true
                }
            })
    })

    const { handleSubmit, register, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        const res = await addNew(data)
        if (res.error) {
            setError({ "error": true, "message": res.response })
            setTimeout(() => {
                setError({ "error": false, "message": "" })
            }, 3000);
        } else {
            reset()
            setError({ "error": false, "message": "" })
            setIsModalNewsAddOpen(false)
            setSuccessAlert("Novedad agregada correctamente")
            setTimeout(() => {
                setSuccessAlert(null)
            }, 3000);
        }
    }
    return (
        <Modal show={isModalNewsAddOpen} position="top-center">
            <div className='flex flex-col p-6 w-[95%] mx-auto'>
                <div className='font-medium text-center'>
                    AGREGAR NUEVA NOVEDAD
                </div>
                <p class='pb-6 font-light text-sm italic'>Los campos señalados con * son obligatorios.</p>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div class="grid grid-cols-1 gap-6">
                        <div class="relative z-0 mb-6 w-full group">
                            <input type="text" {...register("newTitle")} class={style.formInput} placeholder=" " />
                            <label class={style.formLabel}>Titulo*</label>
                            <ErrorWrapper error={errors.newTitle?.message} />
                        </div>
                        <div class="relative z-0 mb-6 w-full group">
                            <textarea rows="4" {...register("newDescription")} class={style.formInput} placeholder=" " />
                            <label class={style.formLabel}>Descripción*</label>
                            <ErrorWrapper error={errors.newDescription?.message} />
                        </div>
                        <div class="flex relative z-0 mb-6 w-full group mx-auto">
                            <div className='w-[70%] mx-auto '>
                                <input type="file" {...register("newFile")} className={style.formInput} placeholder=" " />
                                <label className={style.formLabel}>Imagen png, jpg o jpeg de la novedad, no mayor a 10Mb*</label>
                                <ErrorWrapper error={errors.newFile?.message} />
                            </div>
                        </div>
                        <div class="flex relative z-0 mb-6 w-full group mx-auto">
                            <div className='w-[70%] mx-auto '>
                                <input type="file" {...register("newDocument")} className={style.formInput} placeholder=" " />
                                <label className={style.formLabel}>Archivo pdf, no mayor a 10Mb, campo opcional.</label>
                                <ErrorWrapper error={errors.newDocument?.message} />
                            </div>
                        </div>
                    </div>
                    <div className='text-center flex mb-6'>
                        {error.error && <ErrorWrapper error={error.message} />}
                    </div>
                    <div className='flex flex-col w-[50%] mx-auto'>
                        {loading ? <Loading isLoading={true} /> : <button type="submit" class=" mx-auto bg-gray-300 border shadow hover:text-white hover:bg-green-400 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-6 text-center duration-300 w-full">Agregar Novedad</button>}

                        <button type="button" class="mx-auto bg-gray-200 border shadow hover:text-white hover:bg-teal-400 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center duration-300 w-full" onClick={() => setIsModalNewsAddOpen(false)}>Cancelar</button>
                    </div>
                </form>
            </div>
        </Modal >
    );
}

export default ModalNewsAdd;